import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/bottom-logo.png'
import _imports_1 from '@/assets/images/code1.png'
import _imports_2 from '@/assets/images/code2.png'


const _hoisted_1 = { class: "bottom-box" }
const _hoisted_2 = { class: "bottom-content" }
const _hoisted_3 = { class: "bottom-wrap" }
const _hoisted_4 = { class: "bottom-right" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "filings" }

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const store = useStore()
const router = useRouter()
const linkList: any = [
  {
    title: '产品服务',
    value: [
      {
        name: '数智产品',
        path: '/product_service',
        titleIndex: 1,
        pageTitle: ['产品服务', '数智产品']
      },
      {
        name: '渠道拓展',
        path: '/channel_expansion',
        titleIndex: 1,
        pageTitle: ['产品服务', '渠道拓展']
      }
    ]
  },
  {
    title: '解决方案',
    value: [
      {
        name: '文娱解决方案',
        path: '/solution',
        index: 0,
        titleIndex: 2,
        pageTitle: ['解决方案', '文娱解决方案']
      },
      {
        name: '工业解决方案',
        path: '/solution',
        index: 1,
        titleIndex: 2,
        pageTitle: ['解决方案', '工业解决方案']
      },
      {
        name: '教育解决方案',
        path: '/solution',
        index: 2,
        titleIndex: 2,
        pageTitle: ['解决方案', '教育解决方案']
      },
      {
        name: '医疗解决方案',
        path: '/solution',
        index: 3,
        titleIndex: 2,
        pageTitle: ['解决方案', '医疗解决方案']
      },
      {
        name: '军警部队解决方案',
        path: '/solution',
        index: 4,
        titleIndex: 2,
        pageTitle: ['解决方案', '军警部队解决方案']
      }
    ]
  },
  {
    title: '关于我们',
    value: [
      {
        name: '公司介绍',
        path: '/about_us_view',
        titleIndex: 5,
        pageTitle: ['关于我们', '公司介绍']
      },
      {
        name: '新闻动态',
        path: '/about_us',
        titleIndex: 5,
        pageTitle: ['关于我们', '新闻动态']
      },
      {
        name: '加入我们',
        path: '/about_detail',
        titleIndex: 5,
        pageTitle: ['关于我们', '加入我们']
      }
    ]
  },
  {
    title: '合作咨询',
    value: [
      {
        name: '何洋 13225532650',
        path: ''
      },
      {
        name: '市场/媒体',
        path: '',
      },
      {
        name: 'marketing@nfznxr.com',
        path: ''
      }
    ]
  },
]
const loadUrl: any = ref({})
const to1 = (url: string) => {
  window.scrollTo(0, 0)
  window.location.href = url
}

const changeRouter = (e: any, titleIndex: number) => {
  if (!e.path) return
  if (e.path == '/solution') {
    router.push(`${e.path}?type=${e.index}&pathName=${e.pageTitle[0]},${e.pageTitle[1]}`)
    store.state.programmeIndex = e.index
  } else {
    router.push(`${e.path}?pathName=${e.pageTitle[0]},${e.pageTitle[1]}`);
  }
  store.state.titleIndex = titleIndex;
  store.state.pageTitle = [...e.pageTitle]
}

onMounted(async () => {
  //
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div data-v-0f4cac2f><div class=\"bottom-logo\" data-v-0f4cac2f><img src=\"" + _imports_0 + "\" data-v-0f4cac2f></div><div class=\"bottom-codes\" data-v-0f4cac2f><div data-v-0f4cac2f><img src=\"" + _imports_1 + "\" data-v-0f4cac2f><div data-v-0f4cac2f>公众号</div></div><div data-v-0f4cac2f><img src=\"" + _imports_2 + "\" data-v-0f4cac2f><div data-v-0f4cac2f>视频号</div></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(linkList, (item, index) => {
            return _createElementVNode("div", { key: index }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (e, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["url-list", e.name == '市场/媒体' ? 'blod' : '']),
                  key: i,
                  onClick: ($event: any) => (changeRouter(e, e.titleIndex))
                }, _toDisplayString(e.name), 11, _hoisted_6))
              }), 128))
            ])
          }), 64))
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "line" }, null, -1)),
      _createElementVNode("div", _hoisted_7, [
        _cache[5] || (_cache[5] = _createElementVNode("div", null, "上海市徐汇区钦州北路1001号光启园7号楼6层", -1)),
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(router).push('/privacy_policy');})
          }, "法律声明及隐私政策"),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("span", {
            style: {"color":"#fff"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (to1('https://beian.miit.gov.cn/#/Integrated/index')))
          }, "沪ICP备2023012402号")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            style: {"color":"#fff"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (to1('https://beian.mps.gov.cn/#/query/webSearch')))
          }, "沪公网安备31010402010107号")
        ])
      ])
    ])
  ]))
}
}

})